import { motifValide } from './parcours.js';

export interface EtatEditeur {
  ouvert: boolean;
  sautId: string | null;
  motif: string;
  erreur: string | null;
  occupe: boolean;
}

export type ActionEditeur =
  | { type: 'ouvrir' }
  | { type: 'fermer' }
  | { type: 'demander-saut'; id: string }
  | { type: 'annuler-saut' }
  | { type: 'motif'; valeur: string }
  | { type: 'valider-saut' }
  | { type: 'occupe' }
  | { type: 'termine' }
  | { type: 'echec'; message: string };

export const EDITEUR_INITIAL: EtatEditeur = { ouvert: false, sautId: null, motif: '', erreur: null, occupe: false };

export const MESSAGE_MOTIF = 'Indiquez le motif du saut (trois caractères au moins).';

export function reducerEditeur(etat: EtatEditeur, action: ActionEditeur): EtatEditeur {
  switch (action.type) {
    case 'ouvrir':
      return { ...etat, ouvert: true };
    case 'fermer':
      return EDITEUR_INITIAL;
    case 'demander-saut':
      return { ...etat, sautId: action.id, motif: '', erreur: null };
    case 'annuler-saut':
      return { ...etat, sautId: null, motif: '', erreur: null };
    case 'motif':
      return { ...etat, motif: action.valeur, erreur: null };
    case 'valider-saut':
      return motifValide(etat.motif) ? { ...etat, erreur: null, occupe: true } : { ...etat, erreur: MESSAGE_MOTIF };
    case 'occupe':
      return { ...etat, occupe: true };
    case 'termine':
      return { ...etat, sautId: null, motif: '', erreur: null, occupe: false };
    case 'echec':
      return { ...etat, occupe: false, erreur: action.message };
  }
}
